export const defaultGetParams = (): [] => []

export const payloadAsParam = (_state: any, action: any): [any] => [
  action.payload
]
